import { type ComponentProps, type FC } from 'react';

import { Box } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import { type MaxWidthVariants, maxWidthRecipe } from './MaxWidth.css';

export type MaxWidthProps = ComponentProps<typeof Box> & MaxWidthVariants;

export const MaxWidth: FC<MaxWidthProps> = ({ maxWidth, className, ...props }) => (
  <Box className={getClassNames(maxWidthRecipe({ maxWidth }), className)} {...props} />
);

MaxWidth.displayName = 'MaxWidth';